// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_PaginationBox_boxRoot__vmLga {
  display: flex;
  justify-content: flex-end;
  padding: 8px 16px;
}

.storage_PaginationBox_pagination__h3Jr3 {
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PaginationBox/PaginationBox.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".boxRoot {\n  display: flex;\n  justify-content: flex-end;\n  padding: 8px 16px;\n}\n\n.pagination {\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boxRoot": `storage_PaginationBox_boxRoot__vmLga`,
	"pagination": `storage_PaginationBox_pagination__h3Jr3`
};
export default ___CSS_LOADER_EXPORT___;
